import React, { Component } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { NavLink, Link } from "react-router-dom";
import { greeting, settings } from "../../portfolio";


class Header extends Component {
	render()
	{
		const theme = this.props.theme;
    console.log(theme);
    const link = settings.isSplash ? "/splash" : "home";
	
  return (
		<Fade top duration={1000} distance="20px">
			<div>
				<header className="header">
					<NavLink to="/home" tag={Link} className="logo">
						<span className="grey-color"> &lt;</span>
						<span className="logo-name">Kuljeet Singh</span>
						<span className="grey-color">/&gt;</span>
					</NavLink>
					<input className="menu-btn" type="checkbox" id="menu-btn" />
					<label className="menu-icon" htmlFor="menu-btn">
						<span className="navicon"></span>
					</label>
					<ul className="menu">
						<li>
							<NavLink
								to="/home"
								tag={Link}
								activeStyle={{ fontWeight: "bold" }}
								className="fa fa-home"
							>
								 Home
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/education"
								tag={Link}
								activeStyle={{ fontWeight: "bold" }}
								className="fa fa-cogs"
							>
								Education
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/experience"
								tag={Link}
								activeStyle={{ fontWeight: "bold" }}
								className="fa fa-globe-asia"
							>
								Experience
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/projects"
								tag={Link}
								activeStyle={{ fontWeight: "bold" }}
								className="fa fa-tasks"
							>
								Projects
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/opensource"
								tag={Link}
								activeStyle={{ fontWeight: "bold" }}
								className="fa fa-code-branch"
							>
								Open Source
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/contact"
								tag={Link}
								activeStyle={{ fontWeight: "bold" }}
								className="fa fa-phone-alt"
							>
								Contact Me
							</NavLink>
						</li>
					</ul>
				</header>
			</div>
		</Fade>
	);
  }
}
export default Header;
